import { render, staticRenderFns } from "./handle_bar.vue?vue&type=template&id=83a0ca1a&scoped=true"
import script from "./handle_bar.vue?vue&type=script&lang=js"
export * from "./handle_bar.vue?vue&type=script&lang=js"
import style0 from "./handle_bar.vue?vue&type=style&index=0&id=83a0ca1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a0ca1a",
  null
  
)

export default component.exports